import configPublicFirebase from '@/config/firebaseConfig'
import { getApp, getApps, initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectDatabaseEmulator, getDatabase } from 'firebase/database'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'

// Initialize Firebase app if not already initialized
const app = getApps().length ? getApp() : initializeApp(configPublicFirebase)

// Initialize Firebase Services
const auth = getAuth(app)
const database = getDatabase(app)
const functions = getFunctions(app)

// Set debug token for App Check in development mode
if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_EMULATOR === 'TRUE') {
	self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.VUE_APP_CHECK_DEBUG_TOKEN
}

// Initialize App Check with ReCaptcha Enterprise
const appCheck = initializeAppCheck(app, {
	provider: new ReCaptchaEnterpriseProvider(process.env.VUE_APP_RECAPTCHA_KEY),
	isTokenAutoRefreshEnabled: true,
})

// Development environment setup
// Connect to Firebase emulators in development mode
if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_EMULATOR === 'TRUE') {
	connectAuthEmulator(
		auth,
		`http://${process.env.VUE_APP_EMULATOR_AUTH_HOST}:${process.env.VUE_APP_EMULATOR_AUTH_PORT}`
	)
	connectDatabaseEmulator(
		database,
		process.env.VUE_APP_EMULATOR_DATABASE_HOST,
		Number(process.env.VUE_APP_EMULATOR_DATABASE_PORT)
	)
	connectFunctionsEmulator(
		functions,
		process.env.VUE_APP_EMULATOR_FUNCTIONS_HOST,
		Number(process.env.VUE_APP_EMULATOR_FUNCTIONS_PORT)
	)
}

export { appCheck, auth, database, functions }
